module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record-details-container",
    on: {
      "click": _vm.close
    }
  }, [(_vm.recordCutEnabled) ? _c('RecordCut', {
    attrs: {
      "record": _vm.record,
      "processing": _vm.cutProcessing
    },
    on: {
      "cut-started": _vm.showCutSpinner,
      "cancel": function($event) {
        _vm.recordCutEnabled = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "close close-detail-video",
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "right": "40px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.close($event)
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('v-item-group', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.record.title && _vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('h2', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.record.title))]) : _vm._e(), _vm._v(" "), (_vm.record.description && _vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('h2', {
    directives: [{
      name: "else",
      rawName: "v-else",
      value: (_vm.record.description),
      expression: "record.description"
    }]
  }, [_vm._v(_vm._s(_vm.record.description))]) : _vm._e(), _vm._v(" "), (_vm.record.title && _vm.$root.$children[0].$data.clientId === 'digiteka') ? _c('h2', {
    ref: "testRef",
    staticClass: "align-center record-detail-title"
  }, [_vm._v(_vm._s(_vm.record.title) + "\n      "), (_vm.record.description) ? _c('span', {
    directives: [{
      name: "else",
      rawName: "v-else",
      value: (_vm.record.description),
      expression: "record.description"
    }]
  }, [_vm._v(" (" + _vm._s(_vm.record.description) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-item', [(_vm.record.record_type === 'VIDEO') ? _c('div', [_c('record-player', {
    ref: "playerComponent",
    attrs: {
      "options": _vm.getRecordPlayerOptions(_vm.record)
    }
  }), _vm._v(" "), (!(_vm.record.mldata.approved || _vm.record.mldata.deleted_at || _vm.cutCacheUpdateLock) && _vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('v-btn', {
    staticClass: "btn btn-primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.showRecordCut()
      }
    }
  }, [(_vm.cutProcessing) ? [_c('span', [_vm._v("Cutting")]), _vm._v(" "), _c('span', {
    staticClass: "loading-indicator"
  })] : _c('span', [_vm._v("Cut")])], 2) : _vm._e(), _vm._v(" "), (_vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('v-btn', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]) : _vm._e()], 1) : (_vm.record.record_type === 'IMAGE') ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.record.play_link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.record.thumbnail_link
    }
  })])]) : _vm._e()])], 1), _vm._v(" "), (_vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('v-flex', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('ul', [(_vm.record.title) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.title').toUpperCase()))]), _vm._v(_vm._s(_vm.record.title))]) : _vm._e(), _vm._v(" "), (_vm.record.description) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.description').toUpperCase()))]), _vm._v(_vm._s(_vm.record.description))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.user').toUpperCase()))]), _vm._v(_vm._s(_vm.record.user_full_name))]), _vm._v(" "), (_vm.record.contact_phone) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v("Contact phone")]), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.record.contact_phone
    }
  }, [_vm._v(_vm._s(_vm.record.contact_phone))])]) : _vm._e(), _vm._v(" "), (_vm.record.email) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v("Email")]), _c('a', {
    attrs: {
      "href": 'email:' + _vm.record.email
    }
  }, [_vm._v(_vm._s(_vm.record.email))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.user_group').toUpperCase()))]), _vm._v(" "), _vm._l((_vm.record.groups), function(group) {
    return _c('span', {
      staticClass: "user-group tag"
    }, [_vm._v(_vm._s(group.group_name))])
  })], 2), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.date').toUpperCase()))]), _vm._v(_vm._s(_vm.recordDate))]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.time').toUpperCase()))]), _vm._v(_vm._s(_vm.recordTime) + " " + _vm._s(_vm.recordTz))]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.gps').toUpperCase()))]), _vm._v(_vm._s(_vm.recordCoordinates))]), _vm._v(" "), (_vm.vod) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.duration').toUpperCase()))]), _vm._v(_vm._s(_vm._f("round")(_vm.vod.duration)) + "s")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.device').toUpperCase()))]), _vm._v(_vm._s(_vm.record.device.mobile_type) + " " + _vm._s(_vm.record.device.os_version))]), _vm._v(" "), (_vm.vod) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.resolution').toUpperCase()))]), _vm._v(" " + _vm._s(_vm.vod.width) + " x " + _vm._s(_vm.vod.height))]) : _vm._e(), _vm._v(" "), (_vm.vod) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.size').toUpperCase()))]), _vm._v(_vm._s(_vm._f("filesize")(_vm.vod.size)) + _vm._s(_vm.$t('MB')))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.full_address').toUpperCase()))]), _vm._v(_vm._s(_vm.record.vod_full_address) + " ")]), _vm._v(" "), (_vm.record.comment) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.comment').toUpperCase()))]), _vm._v(_vm._s(_vm.record.comment))]) : _vm._e(), _vm._v(" "), (_vm.isLmrConsumer) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.category').toUpperCase()))]), _vm._v(_vm._s(_vm.record.lmr_category) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "record-attribute",
    staticStyle: {
      "flex": "0 0 200px"
    }
  }, [_vm._v(_vm._s(_vm.$t('detail_video.detected_tags').toUpperCase()))]), _vm._v(" "), (!_vm.editTagsActive) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._l((_vm.tags), function(tag) {
    return _c('span', {
      staticClass: "ml tag"
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "primary",
      "title": "Edit tags"
    },
    on: {
      "click": _vm.toggleEditTagsMode
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/pensil-outline.svg"),
      "alt": "Edit"
    }
  })])], 2) : _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('Multiselect', {
    attrs: {
      "multiple": true,
      "taggable": true,
      "options": _vm.tagsSelectOptions,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.editableTags),
      callback: function($$v) {
        _vm.editableTags = $$v
      },
      expression: "editableTags"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveTags
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleEditTagsMode
    }
  }, [_vm._v("CANCEL")])], 1)])])]) : _vm._e()], 1), _vm._v(" "), (_vm.similarRecords.length) ? _c('div', {
    staticClass: "record-details-similar"
  }, [_c('h4', [_vm._v("Other videos")]), _vm._v(" "), _c('transition-group', {
    staticClass: "record-details-similar-thumbs",
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, _vm._l((_vm.similarRecords), function(record) {
    return _c('thumbnail', {
      key: record.id,
      staticClass: "thumbnail clickable center-block",
      attrs: {
        "media": record.media,
        "default": record.thumbnail_link
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.clickedRecordHandler(record)
        }
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600776a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/RecordDetails.vue
// module id = 1047
// module chunks = 1